import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Divider, Form, Input, Row, Tabs } from "antd";
import Table, { ColumnProps } from "antd/lib/table";
import { DatePicker, Space } from "antd";
import {RequestService} from '../../../../../../shared-services/vms/src/lib/request.service';
import FormItem from "antd/lib/form/FormItem";
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { SearchOutlined,UndoOutlined } from '@ant-design/icons';
import Search from "antd/lib/input/Search";
import moment from "moment";
import Highlighter from 'react-highlight-words';
import { RequestReport } from "libs/shared-models/vms/src/lib/request-form/report.dto";
import { RequestById } from "libs/shared-models/vms/src/lib/request-form/request.request";




/* eslint-disable-next-line */
export interface ReportProps {}
export const InsideFactoryReport = (props: ReportProps) => {
  const [page, setPage] = React.useState(1);
  const { RangePicker } = DatePicker;
  const service = new RequestService();
  const [form] =Form.useForm();
  const [selectedDateData, setselectedDateData] = useState<any[]>([]);
  const [requestdata, setRequestData] = useState<any[]>([])
  const onSearch = (value: string) => console.log(value);
  const [searchText, setSearchText] = useState('');
  const[searchedColumn,setSearchedColumn]=useState('');
  const searchInput = useRef(null);
  const { TabPane } = Tabs;

  useEffect(() => {
    getAllCheckIn()
    // getExpiredRequests()
  },[])
  
  const getAllCheckIn = () => {
    const req = new RequestById(0)
    service.getAllCheckIn(req).then(res => {
      if(res.status){
        setRequestData(res.data)
        console.log(res.data,"setRequestData")
        AlertMessages.getSuccessMessage(res.internalMessage)
      }else{
        AlertMessages.getErrorMessage(res.internalMessage)
    }
    })
    
  
   }

//   const getExpiredRequests = () => {
//     service.getExpiredRequests().then(res => {
//         if(res.status){
//           setRequestData(res.data);
//             AlertMessages.getSuccessMessage(res.internalMessage)
//         }else{
//             AlertMessages.getErrorMessage(res.internalMessage)
//         }

//     })
// }

  const getDateReport = (req) => {
    console.log(req,"req");
    service.getDateReport(req).then(res=> {
      if(res.status) {
        console.log(requestdata,"intidata")
        setselectedDateData(res.data)
        setRequestData([])
        setRequestData(res.data)
        console.log(res,"*********")
        console.log(requestdata,"dataaaaaaaa")
        AlertMessages.getSuccessMessage(res.internalMessage)
      } else {
        setRequestData([])
        AlertMessages.getErrorMessage(res.internalMessage)
      }
    })
  }

 const searchData = () => {
    const fromDate = form.getFieldValue('Date')?(moment(form.getFieldValue('Date')[0]).format("YYYY-MM-DD")): null;
    const toDate = form.getFieldValue('Date')?(moment(form.getFieldValue('Date')[1]).format("YYYY-MM-DD")): null;
    console.log(fromDate,"fromdate");
    console.log(toDate,"todate");
    const selectedDate={fromDate,toDate};
    console.log(selectedDate,"*")
    
     getDateReport(selectedDate)
    form.resetFields();
  }

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
          ),
          filterIcon: filtered => (
            <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
          ),
          onFilter: (value, record) =>
            record[dataIndex]
              ? record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
              : false,
          onFilterDropdownVisibleChange: visible => {
            console.log(searchInput.current);
            if (visible) { setTimeout(() => searchInput.current.select()); }
          },
          render: text =>
            text ? (
              searchedColumn === dataIndex ? (
                <Highlighter
                  highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={text.toString()}
                />
              ) : text
              ) : null
      
        });

        function handleSearch(selectedKeys, confirm, dataIndex) {
          confirm();
          setSearchText(selectedKeys[0]);
          setSearchedColumn(dataIndex);
        };
      function handleReset(clearFilters) {
          clearFilters();
          setSearchText('');
        };
  
  const tableColumns = (key) => {
    const columns: ColumnProps<any>[] = [
      {
        title: "S.No",
        key: "sno",
        width: "30px",
        responsive: ["sm"],
        render: (text, object, index) => (page - 1) * 10 + (index + 1)
      },
      {
        title: "Requisition ID",
        dataIndex: "requestId",
        width: 130,
        align: "left",
        ...getColumnSearchProps('requestId')
      },
      {
        title: "Visitor's Name",
        dataIndex: "visitorName",
        width: 150,
        align: "left"
      },
      {
        title: "Check In",
        dataIndex: "checkIn",
        width: 150,
        align: "left"
      },
      {
        title: "Check Out",
        dataIndex: "checkOut",
        width: 150,
        align: "left"
      }
    ];
    if (key === "1") {
      return [...columns];
    } else {
      return [...columns];
    }
  };
  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };
      const onClick= (val) => {
        console.log(val,"val")
      }
  
  const resetHandler = () => {
    form.resetFields();
     getAllCheckIn()
  }
  return (
    <Card
      title={<span style={{ color: "white" }}>Inside Factory Report</span>}
      style={{ textAlign: "center" }}
      headStyle={{ backgroundColor: "#69c0ff", border: 0 }}
    >
      <br></br>
      <Form form={form} layout='vertical'>
      <Row>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
              <Form.Item name="Date">
                <RangePicker />
              </Form.Item>
            </Col>
             <Col  style={{ margin: '1%' }}>
               <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  // size="small"
                  block onClick={() => searchData()}
                  
                >
                  Get Report
                </Button>
              </Col> 
              <Col style={{ margin: '1%' }}>
            <Button
              type="primary"
              icon={<UndoOutlined />}
              onClick={resetHandler}
            >
              Reset
            </Button>
            </Col>
            
            <br></br>           
        </Row>
        </Form>
      <Tabs>
        <TabPane>
          <Table
            rowKey={(record) => record.id}
            columns={tableColumns("1")}
            dataSource={requestdata}
            scroll={{ x: true }}
            pagination={{
              showSizeChanger : true,
              onChange(current) {
                setPage(current);
              }
            }}
            onChange={onChange}
            bordered
          />
        </TabPane>
      </Tabs>
    </Card>
  );

};
export default InsideFactoryReport;
